import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { loadScript } from '../../lib/script-loader'
import styles from './instagram-post.css'

const INSTAGRAM_EMBED_SCRIPT_ID = 'instagram-embed-script'
const INSTAGRAM_EMBED_SCRIPT_URL = 'https://www.instagram.com/embed.js'

const processEmbeds = () => {
  if (window.instgrm && window.instgrm.Embeds) {
    window.instgrm.Embeds.process()
  }
}

function InstagramPost({ permalink }) {
  useEffect(() => {
    const existingScript = document.getElementById(INSTAGRAM_EMBED_SCRIPT_ID)

    if (existingScript) {
      existingScript.addEventListener('load', processEmbeds)
      processEmbeds()

      return () => existingScript.removeEventListener('load', processEmbeds)
    }

    loadScript(
      INSTAGRAM_EMBED_SCRIPT_URL,
      processEmbeds,
      { id: INSTAGRAM_EMBED_SCRIPT_ID }
    )

    return undefined
  }, [permalink])

  return (
    <div className={styles.wrapper}>
      <blockquote
        className={`instagram-media ${styles.embed}`}
        data-instgrm-permalink={permalink}
        data-instgrm-version="14"
      >
        <a href={permalink} target="_blank" rel="noopener noreferrer">
          View this post on Instagram
        </a>
      </blockquote>
    </div>
  )
}

InstagramPost.propTypes = {
  permalink: PropTypes.string.isRequired
}

export default InstagramPost
